import { render, staticRenderFns } from "./Boards.vue?vue&type=template&id=9c3e8744&scoped=true"
import script from "./Boards.vue?vue&type=script&lang=js"
export * from "./Boards.vue?vue&type=script&lang=js"
import style0 from "./Boards.vue?vue&type=style&index=0&id=9c3e8744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c3e8744",
  null
  
)

export default component.exports